import { __assign, __extends, __rest } from "tslib";
import { Shape } from '../types';
import { DisplayObject } from './DisplayObject';

var Group =
/** @class */
function (_super) {
  __extends(Group, _super);

  function Group(_a) {
    if (_a === void 0) {
      _a = {};
    }

    var style = _a.style,
        rest = __rest(_a, ["style"]);

    return _super.call(this, __assign({
      type: Shape.GROUP,
      style: __assign({
        width: 'auto',
        height: 'auto',
        textAlign: 'inherit',
        fontSize: 'inherit'
      }, style)
    }, rest)) || this;
  }

  return Group;
}(DisplayObject);

export { Group };